import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Switch } from 'react-router-dom';
import ContactDOP from '~/pages/ContactDPO';
import ContactDPOLogado from '~/pages/ContactDPOLogado';
import DocumentDetail from '~/pages/DocumentDetail';
import EliminacaoAnonimizacao from '~/pages/EliminacaoAnonimizacao';
import ExportarInformacoesOperacoes from '~/pages/ExportarInformacoesOperacoes';
import GerenciarConsentimento from '~/pages/GerenciarConsentimento';
import Helpe from '~/pages/Helpe';
import Home from '~/pages/Home';
import MostrarInformacoesPessoais from '~/pages/MostrarInformacoesPessoais';
import SegurancaInformacao from '~/pages/SegurancaInformacao';
import SignIn from '~/pages/SignIn';
import Route from '~/routes/Route';
import { ApplicationState } from '~/store';

const Routes = () => {
  const company = useSelector<ApplicationState, any>(
    state => state.auth.company,
  );

  return (
    <Switch>
      <Route exact path="/" component={Helpe} />
      <Route exact path="/helpe" component={Helpe} />
      <Route exact path="/seginfo" component={SegurancaInformacao} />
      <Route exact path="/:country_company" component={SignIn} />
      <Route exact path="/:country_company/home" component={Home} isPrivate />
      <Route
        exact
        path="/:country_company/home/mostrar-informacoes-pessoais"
        component={MostrarInformacoesPessoais}
        isPrivate
      />
      <Route
        exact
        path="/:country_company/home/exportarinformacoes-operacoes"
        component={ExportarInformacoesOperacoes}
        isPrivate
      />
      <Route
        exact
        path="/:country_company/home/eliminacao-anonimizacao"
        component={EliminacaoAnonimizacao}
        isPrivate
      />
      <Route
        exact
        path="/:country_company/home/gerenciar-consentimento"
        component={GerenciarConsentimento}
        isPrivate
      />
      <Route
        exact
        path="/:country_company/contactdpo"
        component={ContactDOP}
        isPublic
      />
      <Route
        exact
        path="/:country_company/home/contactdpo"
        component={ContactDPOLogado}
        isPrivate
      />
      <Route
        render={props => <DocumentDetail {...props} />}
        exact
        path="/:country_company/:slug"
        isPublic
      />

      <Redirect from="*" to={`/${company?.path_alias_nm}`} />
    </Switch>
  );
};

export default Routes;
